<template>
  <van-tabbar
    v-model="tabActive"
    active-color="#bc4853"
    class="tab-bar"
    @change="onTabBarChange"
  >
    <van-tabbar-item name="/">
      <template #icon>
        <van-icon
          class-prefix="icon" name="mudedi"
          size="28"
        />
      </template>
      <span>走进五夫</span>
    </van-tabbar-item>
    <van-tabbar-item name="/cate?type=culture">
      <template #icon>
        <van-icon
          class-prefix="icon" name="huwai"
          size="28"
        />
      </template>
      <span>文旅路线</span>
    </van-tabbar-item>

    <van-tabbar-item name="/cate?type=industrial">
      <template #icon>
        <van-icon
          class-prefix="icon" name="jingdian"
          size="28"
        />
      </template>
      <span>产业线路</span>
    </van-tabbar-item>

    <van-tabbar-item name="/strategy">
      <template #icon>
        <van-icon
          class-prefix="icon" name="ziranfengguang"
          size="28"
        />
      </template>
      <span>旅游攻略</span>
    </van-tabbar-item>
    <van-tabbar-item name="/food">
      <template #icon>
        <van-icon
          class-prefix="icon" name="canyin"
          size="28"
        />
      </template>
      <span>吃住推荐</span>
    </van-tabbar-item>
    <van-tabbar-item name="/attr">
      <template #icon>
        <van-icon
          class-prefix="icon" name="yule"
          size="28"
        />
      </template>
      <span>项目招商</span>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CustomTabBar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["menus"]),
    tabActive: {
      get() {
        return this.$store.state.active;
      },
      set(value) {
        this.$store.commit("SET_ACTIVE", value);
      },
    },
  },
  watch: {
    $route(to, form) {
      this.$store.commit("SET_ACTIVE", to.fullPath);
    }
  },
  methods: {
    onTabBarChange(index) {
      this.$router.push({ path: index });
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-bar {
  ::v-deep .van-icon__image {
    height: 30px !important;
  }
}
</style>
